import { useMemo } from 'react';

// material-ui
import { Menu } from '@mui/icons-material';
import { Box, Drawer, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project imports
import { useDispatch, useSelector } from 'src/store';
import { drawerWidth } from 'src/store/constant';
import { openDrawer } from 'src/store/slices/menu';

import LogoSection from '../LogoSection';

import MenuList from './MenuList';

// ==============================|| SIDEBAR DRAWER ||============================== //

interface SidebarProps {
    window?: Window;
}

const Sidebar = ({ window }: SidebarProps) => {
    const theme = useTheme();
    const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const drawer = useMemo(
        () => (
            <Box
                sx={{
                    height: '100vh',
                    overflowY: 'auto',
                    paddingBottom: '32px',
                    textAlign: 'left',
                }}
            >
                <MenuList />
            </Box>
        ),
        [matchUpMd]
    );

    const container = window !== undefined ? () => window.document.body : undefined;

    if (!drawerOpen) {
        return (
            <Box
                marginTop="36px"
                marginLeft="24px"
                height="32px"
                width="32px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                    background: 'linear-gradient(90deg, #F7971E 0%, #FFD200 100%)',
                    borderRadius: '8px',
                }}
                onClick={() => dispatch(openDrawer(true))}
                data-testid="sidebar-menu-expand-button"
            >
                <Menu sx={{ color: 'white' }} />
            </Box>
        );
    }

    return (
        <Box component="nav" aria-label="mailbox folders" height="100%">
            <Drawer
                container={container}
                variant={matchUpMd ? 'persistent' : 'temporary'}
                anchor="left"
                open={drawerOpen}
                onClose={() => dispatch(openDrawer(!drawerOpen))}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.dark[800],
                        color: theme.palette.text.secondary,
                        borderRight: 'none',
                        padding: '24px',
                        position: 'fixed',
                        zIndex: matchUpMd ? 0 : 1200,
                        height: '100%',
                    },
                }}
                ModalProps={{ keepMounted: true }}
                color="inherit"
            >
                <LogoSection />
                {drawer}
            </Drawer>
        </Box>
    );
};

export default Sidebar;
